import { render } from "./MobileKaiJsp.vue?vue&type=template&id=2af6d50c&scoped=true"
import script from "./MobileKaiJsp.vue?vue&type=script&lang=js"
export * from "./MobileKaiJsp.vue?vue&type=script&lang=js"

import "./MobileKaiJsp.vue?vue&type=style&index=0&id=2af6d50c&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1e77ff55b92932984816aac78a22ff52/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af6d50c"]])

export default __exports__